import { useEffect } from 'react'
import { history, setCommonModuleValues, getAuthState } from '../common/utils/Sparky'
import type { Location } from 'history'

const TSG_ID_QUERY_NAMES = ['tsg_id', 'tsgid', 'tsgId', 'tsg-id', 'tsg']
const TSG_ID_NONE = 'none'
const getTsgIdFromQuery = ({ search }: Location): string | undefined => {
  const urlParams = new URLSearchParams(search)
  for (const key of TSG_ID_QUERY_NAMES) {
    const tsgId = urlParams.get(key)?.replace(/\W/g, '')
    if (tsgId && tsgId !== TSG_ID_NONE) {
      return tsgId
    }
  }
  return undefined
}
const cleanupTsgIdFromQuery = ({ search, pathname }: Location) => {
  const urlParams = new URLSearchParams(search)
  TSG_ID_QUERY_NAMES.forEach(key => urlParams.delete(key))
  history.replace({
    pathname,
    search: urlParams.toString(),
  })
}

const useSelecetedTsg = (location: Location) => {
  useEffect(() => {
    const tsgId = getTsgIdFromQuery(location)
    if (tsgId) {
      const tsg = getAuthState().tsgs.get(tsgId)
      if (tsg) {
        setCommonModuleValues({ tsg })
      }
      cleanupTsgIdFromQuery(location)
    }
  }, [location])
}

export default useSelecetedTsg
